<div class="pill-container" fxLayout="column">
  <div fxLayout="row nowrap" fxLayoutAlign="start center" fxLayoutGap="20px">
    <span>{{ text }}</span>
    <i class="fas fa-times-circle" (click)="onDelete()" *ngIf="!hideIcon && !loading"></i>
    <i class="fas fa-circle-notch fa-spin" *ngIf="loading"></i>
  </div>
</div>
